import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { ECategory } from '../../../repositories/offer-card/entities/offer/OfferSchema';

export const isBusinessSale = (offer: IOfferSchema): boolean => offer.category === ECategory.BusinessSale;
